export default "__VITE_ASSET__BeLAStCm__"